import Resume from "../assets/resume.png";
import Gmail from "../assets/Gmail.png";
import Whatsapp from "../assets/Whatsapp.png";
import sign_light from "../assets/signature_light.png";
import sign_dark from "../assets/signature_dark.png";
import promptophobia from "../assets/Works/promptOphobia.jpg";
import gamewareshub from "../assets/Works/GameWaresHub.jpg";
import gamewareshub1 from "../assets/Works/GameWaresHub-1.jpg";
import gamewareshub2 from "../assets/Works/GameWaresHub-2.png";
import gamewareshub3 from "../assets/Works/GameWaresHub-3.png";
import gamewareshub4 from "../assets/Works/GameWaresHub-4.png";
import gamewareshub5 from "../assets/Works/GameWaresHub-5.png";
import gradecalc from "../assets/Works/GradeCalc.jpg";
import gradecalc1 from "../assets/Works/GradeCalc-1.jpg";
import lavenderlogs from "../assets/Works/LavenderLogs.jpg";
import lavenderlogs2 from "../assets/Works/LavenderLogs-2.png";
import lavenderlogs3 from "../assets/Works/LavenderLogs-3.png";
import lavenderlogs4 from "../assets/Works/LavenderLogs-4.png";
import lavenderlogs5 from "../assets/Works/LavenderLogs-5.png";
import moviebase from "../assets/Works/Moviebase.jpg";
import moviebase1 from "../assets/Works/Moviebase-1.png";
import moviebase2 from "../assets/Works/Moviebase-2.png";
import moviebase3 from "../assets/Works/Moviebase-3.png";
import shadowsensei from "../assets/Works/ShadowSensei.jpg";
import shadowsensei1 from "../assets/Works/ShadowSensei-1.jpg";
import shadowsensei2 from "../assets/Works/ShadowSensei-2.jpg";
import shadowsensei3 from "../assets/Works/ShadowSensei-3.jpg";
import shadowsensei5 from "../assets/Works/ShadowSensei-5.jpg";
import arcadevault from "../assets/Works/Arcade-Vault.jpg";
import arcadevault1 from "../assets/Works/Arcade-Vault-1.png";
import arcadevault2 from "../assets/Works/Arcade-Vault-2.png";
import arcadevault3 from "../assets/Works/Arcade-Vault-3.png";
import arcadevault4 from "../assets/Works/Arcade-Vault-4.png";
import arcadevault5 from "../assets/Works/Arcade-Vault-5.png";
import investmenttracker from "../assets/Works/investment-tracker.png";
import investmenttracker1 from "../assets/Works/investment-tracker-1.png";
import investmenttracker2 from "../assets/Works/investment-tracker-2.png";
import investmenttracker3 from "../assets/Works/investment-tracker-3.png";
import investmenttracker4 from "../assets/Works/investment-tracker-4.png";
import investmenttracker5 from "../assets/Works/investment-tracker-5.png";
import investmenttracker6 from "../assets/Works/investment-tracker-6.png";
import investmenttracker7 from "../assets/Works/investment-tracker-7.png";
import investmenttracker8 from "../assets/Works/investment-tracker-8.png";
import investmenttracker9 from "../assets/Works/investment-tracker-9.png";
import investmenttracker10 from "../assets/Works/investment-tracker-10.png";
import investmenttracker11 from "../assets/Works/investment-tracker-11.png";
import investmenttracker12 from "../assets/Works/investment-tracker-12.png";
import investmenttracker13 from "../assets/Works/investment-tracker-13.png";
import investmenttracker14 from "../assets/Works/investment-tracker-14.png";
import investmenttracker15 from "../assets/Works/investment-tracker-15.png";
import pranalysisdashboard from "../assets/Works/PR-Analysis-Dashboard.jpg";
import pranalysisdashboard1 from "../assets/Works/PR-Analysis-Dashboard-1.jpg";
import pranalysisdashboard2 from "../assets/Works/PR-Analysis-Dashboard-2.jpg";
import pranalysisdashboard3 from "../assets/Works/PR-Analysis-Dashboard-3.jpg";
import pranalysisdashboard4 from "../assets/Works/PR-Analysis-Dashboard-4.jpg";
import pranalysisdashboard5 from "../assets/Works/PR-Analysis-Dashboard-5.jpg";
import pranalysisdashboard6 from "../assets/Works/PR-Analysis-Dashboard-6.jpg";
import pranalysisdashboard7 from "../assets/Works/PR-Analysis-Dashboard-7.jpg";
import pranalysisdashboard8 from "../assets/Works/PR-Analysis-Dashboard-8.jpg";
import pranalysisdashboard9 from "../assets/Works/PR-Analysis-Dashboard-9.jpg";

// Profile Picture
import profileLogo from "../assets/profileLogo.png";

// Logos
import reactLogo from "../assets/Logos/react.svg";
import expressLogo from "../assets/Logos/express.svg";
import gitLogo from "../assets/Logos/git.svg";
import javaLogo from "../assets/Logos/java.svg";
import javascriptLogo from "../assets/Logos/javascript.svg";
import mongoLogo from "../assets/Logos/mongo.svg";
import mysqlLogo from "../assets/Logos/mysql.svg";
import nodejsLogo from "../assets/Logos/nodejs.svg";
import prismaLogo from "../assets/Logos/prisma.svg";
import pythonLogo from "../assets/Logos/python.svg";
import tailwindLogo from "../assets/Logos/tailwind.svg";
import typescriptLogo from "../assets/Logos/typescript.svg";
import zodLogo from "../assets/Logos/zod.svg";

const images = {
  Resume,
  Gmail,
  Whatsapp,
  sign_light,
  sign_dark,
  promptophobia,
  gamewareshub,
  gamewareshub1,
  gamewareshub2,
  gamewareshub3,
  gamewareshub4,
  gamewareshub5,
    gradecalc,
    gradecalc1,
  lavenderlogs,
  lavenderlogs2,
  lavenderlogs3,
  lavenderlogs4,
  lavenderlogs5,
    moviebase,
    moviebase1,
    moviebase2,
    moviebase3,
    shadowsensei,
    shadowsensei1,
    shadowsensei2,
    shadowsensei3,
    shadowsensei5,
    arcadevault,
    arcadevault1,
    arcadevault2,
    arcadevault3,
    arcadevault4,
    arcadevault5,
    investmenttracker,
    investmenttracker1,
    investmenttracker2,
    investmenttracker3,
    investmenttracker4,
    investmenttracker5,
    investmenttracker6,
    investmenttracker7,
    investmenttracker8,
    investmenttracker9,
    investmenttracker10,
    investmenttracker11,
    investmenttracker12,
    investmenttracker13,
    investmenttracker14,
    investmenttracker15,
    pranalysisdashboard,
    pranalysisdashboard1,
    pranalysisdashboard2,
    pranalysisdashboard3,
    pranalysisdashboard4,
    pranalysisdashboard5,
    pranalysisdashboard6,
    pranalysisdashboard7,
    pranalysisdashboard8,
    pranalysisdashboard9,

  // Logos
  reactLogo,
  expressLogo,
  gitLogo,
  javaLogo,
  javascriptLogo,
  mongoLogo,
  mysqlLogo,
  nodejsLogo,
  prismaLogo,
  pythonLogo,
  tailwindLogo,
  typescriptLogo,
  zodLogo,

  profileLogo,
};

export default images;
